import Vue from 'vue';
import R3 from '@syman/burgeon-r3';
// import '@syman/burgeon-r3/r3.publish/r3.min.css';
import { i18nPlugin } from "@voerkai18n/vue2"
import './src/assets/css/index.less';
import { setInputRegex } from './src/config/config/setRegex.js';
import { i18nScope, t } from "./src/languages"

Vue.use(i18nPlugin, { i18nScope })

/* Vue.use(jflowPlugin.default, {
  changePattern: true,
  // gateway: 'ad-app',
  // roleSwitch:false
}) */

const lan = localStorage.getItem('locale') || 'zh';
await VoerkaI18n.change(lan) // 在登录页刷新时翻译失效，时机问题

// 根据接口调整title
const appTitle = lan == 'en' ? 'R3 2.0' : 'R3 2.0';
document.title = appTitle;
import './elementUI';
import './index.publish';
import beforeRender from './src/config/minxin/beforeRender';
import beforeActionModalOpen from './src/config/minxin/beforeActionModalOpen';
console.log('OMS::', OMS);

// OMS.setCusExternalTreeDatas(tree);
import wp from './src/component/commonPages/WelcomePage.vue';
import lg from './src/component/commonPages/Login.vue';
import resetDom from './src/component/omsui/directive/resetDom';
import projectRouterConfig from './src/config/config/router.config'

R3.launchApplication({
  quietRoutes: ['/forgotPassword'], //未登录状态下刷新页面停留在当前页面
  projectRoutes: projectRouterConfig,
  blockFullOperation: true, // 禁止不选数据时的批量修改操作,
  computeForSubtable: true,
  globalDropFilterMode: true, // 全局开启下拉筛选模式(即在fktable里面进行模糊搜索)
  ResetrouterBackLogic: true, // 超链接跳转的去的目标页面显示返回按钮, 并完成从哪儿来的回哪儿去功能（待全面测试）
  notificationOfMain: true, // 控制主表字段修改是否派发事件
  asyncTaskScheme: 'skq',
  getMsgCntTime: 10*1000, // 消息轮循时间调整为10秒
  enableAsyncTaskTip: false, // 不弹'当前会全量导出'的提示
  routerFilter: false,
  autoGatewayUrl: true,
  layoutDirection: true, // 结构：左边菜单(NavigatorSubMenu.vue)，上边收藏栏(NaVerticalslot.vue)。layoutDirection: true
  editableDate: true, // 日期组件是否可编辑
  image: OMS.image,
  globalComponent: {
    Login: lg,
    WelcomePage: wp,
  },
  /* externalPluginModules: {
    INSTANCEMANAGEMENTLIST: {
        // jflow插件待办列表界面
        component: jflowPlugin.components(),
        name: '工作流',
    },
  }, */
  connector: OMS.connector,
  externalModules: OMS.cusPageConfig(), // 自定义界面
  externalModals: OMS.cusModalConfig(), // 自定义弹框
  customizeWaterMark: OMS.cusWaterMarkConfig, // 水印配置,
  externalTreeDatas: OMS.cusExternalTreeDatas, // 扩展树型数据展示开关;
  domPortal: {
    // 水印位置转移
    waterMark(params) {
      if (params.fromComponent === 'SingleObjectButtons') {
        return params.type === 'horizontal' ? '.panelForm' : '.verticalTableDetailContent'; // 返回需要挂载水印的节点类名
      }
      return false;
    },
  },
  listFormWebconf: ['filtercolval'], // 列表查询支持webcof字段
  formItemMixins: OMS.ExMixin,
  customizeMixins: {
    horizontalTableDetailCustomize: OMS.VTDC(), // 左右结构单对象界面配置项
    verticalTableDetailCustomize: OMS.VTDC(), // 上下结构单对象界面配置项
    standardTableListsCustomize: OMS.STLC(), // 标准列表界面混入文件
    tableDetailCollectionMixin: OMS.TDCM, // 获取所有外部接入的mixins对象
    setPanel: {
      mounted() {
        this.customizeComponent = () => import('@/component/settingPanel');
      },
    },
    tabList: {
      methods: {
        R3_beforeHandleClose(menu) {
          const tableArr = ['ST_C_STORAGE_SOURCING_STRATEGY_TOB']
          if (tableArr.includes(menu.tableName) && /CUSTOMIZED/.test(vm.$route.fullPath)) {
            return new Promise(resolve => {
              const $_live_getChildComponent = this.$_live_getChildComponent(window.vm, R3.getModuleName()); // 获取组件实列
              setTimeout(() => {
                let result = $_live_getChildComponent.close()
                resolve(result)
              }, 300);
            })
          } else {
            return Promise.resolve(true)
          }
        }
      }
    }
  },
  // appLayout: OMS.appLayoutScript,
  // appLayout: require('./src/appLayout.js'),
  layoutDirectionSlot: {
    // 菜单子系统渲染文件
    // navigator: () =>
    //     import ('./src/component/commonPages/layout/NavigatorSlotDemo.vue'), // 导入我们定制的水平导航
    standardTableList: OMS.STLD,
    listFormButton: OMS.listFormButton,
    NavigatorSubMenu: OMS.NavigatorSubMenu, // 左侧菜单 配合'NaVerticalslot.vue'（顶部收藏夹）使用
    NaVertical: OMS.NaVerticalslot,
  },
  customizeMainTableField: OMS.formDefined, // 定制表单面板 配置项
  // 标准agTAble配置（目前只支持高度设置）
  agGridOptions: {
    rowHeight: 40,
    agHidePaste: true, // 隐藏ag粘贴
  },
  Version: '1.3', // 版本号
  enableGateWay: false, // 网关是否打开,
  requestPenddingExpire: 100, // 全局设置请求代理防暴力点击，在network.post请求参数里随便塞个字段放时间戳可以绕过该机制
  isItemTableNewValidation: false, // 子表有必填项时，是否校验子表（如为true,则直接校验. 如为false,则输入值才触发子表必填项校验,不输入则只校验主表）
  // filterUrlForNetwork: CustomConfig.filterUrlConfig, // 过滤不需要用框架报错提示信息的接口请求
  // filterUrlForNetworkScript: CustomConfig.filterUrlForNetworkScript, // 导入的filterUrlForNetworkScript脚本文件
  messageSwitch: true, // 1.4 导入开启异步任务
  enableTaskNotice: true, // 异步任务提示
  imgProgressController: true, // 图片上传进度条显示
  useAgGrid: true, // 明细支持用ag表格渲染
  beforeRender,
  saveNoModifyTables: ['OC_B_VIPCOM_DISTRIBUTION', 'DC_B_APPLY_ORDER', 'ST_C_STORE_SETTING', 'SG_C_PERCENT_STRATEGY'], // 就算主表没有表单变更也走保存
  beforeActionModalOpen,
  setComponentsProps: (type, props = {}) => {
    if (type === 'OBJ_SELECT') {
      // props.chooseAll = false;
      props.multipleType = true; // 取消全选
      props.filterable = true; // 开启模糊搜索
    }
    if (type === 'String' && props.options.colname == 'TEST') {
      // props.customizedDefaultValue = $pageNote[props.options.tableName];
    }
    // 下拉多选 添加模糊查询多选功能
    if (type === 'OBJ_FK') {
      if (props.PropsData.fkobj.searchmodel === 'mrp') {
        props.filterMode = true;
      }
    }

    setInputRegex(props);

    return props;
  },
  enableLoginPro: true,
  filterURL: [/\/p\/c\/code\/login*/g, /\/p\/c\/message\/login*/g], // 过滤登录接口，避免走公共的network方法里，导致弹窗出错
  hugeQuery: [
    // 海量标记-表明和跳转方式（左右是H，上下是V）
    { table: 'SG_B_STO_TRANSFER', tabpanle: 'V' },
  ],
});

// 路由守卫 - 全局前置守卫
R3.router.beforeEach((to, from, next) => {
  OMS.beforeEach(to, from, next);
});
R3.router.afterEach((to, from) => {
  OMS.cssHandleUtils.iframeStyle();
});

// // 存储可视化宽度
// let clientWidthsFun = () => {
//   let clientWidths = document.body.clientWidth;
//   if (clientWidths < 990) { $store.commit('customize/colRowNum', 3); } else { $store.commit('customize/colRowNum', 4); }
// };
// clientWidthsFun();
// // 屏幕变化
// window.onresize = () => clientWidthsFun();

// 挂载network
window.$network = R3.network;
//   }, 1000)
// });

const setXss = () => {
  // 安全攻击
  let htmlEncodeByRegExp = (str) => {
    let s = str
    if (str.length === 0) {
      return ''
    }
    // s = s.replace(/\&/g, '&#38;')
    s = s.replace(/&(?![a-z0-9#]{1,7};|#[0-9]{1,7};|lt;|gt;|nbsp;)/g, '&amp;');
    s = s.replace(/</g, '&lt;')
    s = s.replace(/>/g, '&gt;')
    // s = s.replace(/ /g, '&nbsp;')
    // s = s.replace(/\//g, '&#47;')
    s = s.replace(/\'/g, '&#39;') //eslint-disable-line
    s = s.replace(/\"/g, '&quot;') //eslint-disable-line
    return s
  }
  let debouncedHandler = _.debounce(function(e) {
    const tagName = e.target.tagName.toLowerCase()
    if (tagName === 'input' || tagName === 'textarea') {
      e.target.value = htmlEncodeByRegExp(e.target.value);
      e.target.dispatchEvent(event);
    }
  }, 200);
  var event = document.createEvent("Event")
  event.initEvent("input")

  document.body.addEventListener('compositionstart', function(e) {
    e.target.isComposing = true;
  });

  document.body.addEventListener('compositionend', function(e) {
    e.target.isComposing = false;
    debouncedHandler(e);
  });

  document.body.addEventListener('input', function(e) {
    if (!e.target.isComposing) {
      debouncedHandler(e);
    }
  });
}
// setXss()

Vue.mixin({
  mounted() {
    OMS.cssHandleUtils.globalBtnDelay();
    OMS.cssHandleUtils.closeBrowserAutocomplete();
    OMS.cssHandleUtils.disableMopInputFk();
  },
});
Vue.directive('resetDom', resetDom); // 物流轨迹-step标题样式处理
